import React, { useEffect, useState, useCallback } from "react";
import axios from "axios";
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../contexts/AuthContext';
import { useLocation, useNavigate, Link } from "react-router-dom";
import Breadcrumbs from './Breadcrumbs';
const API_URL = process.env.REACT_APP_API_URL;

const Header = ({ selectedDropdown, setSelectedDropdown }) => {
  const { t } = useTranslation(['header', 'common']);
  const location = useLocation();
  const navigate = useNavigate();
  // Initialize user from localStorage for immediate display
  const [user, setUser] = useState(() => {
    const storedUser = localStorage.getItem("user");
    return storedUser ? JSON.parse(storedUser) : null;
  });
  const [allowedAssessments, setAllowedAssessments] = useState([]);
  const [unreadAnnouncementsCount, setUnreadAnnouncementsCount] = useState(0);
  console.log("user =>", user);

  const fetchUserDetails = useCallback(() => {
    // Fetch logged-in user details
    axios
      .get(`${API_URL}api/userr-detail/`, { withCredentials: true })
      .then((response) => {
        console.log(" userr-detail response =>", response.data);

        if (response.data.first_name) {
          setUser(response.data); // Store user details in state
          localStorage.setItem("role", response.data.role); // Store role locally
          localStorage.setItem("user", JSON.stringify(response.data)); // Add this line

        } else {
          console.error("No user data found:", response.data);
        }
      })
      .catch((error) => {
        console.error("Error fetching user details:", error);
      });

    // Fetch allowed assessments
    axios
      .get(`${API_URL}api/get_cara_login_users/`, { withCredentials: true })
      .then((response) => {
        if (Array.isArray(response.data) && response.data.length > 0) {
          const userCapabilities = response.data[0].capabilities || [];
          setAllowedAssessments(userCapabilities);
        }
      })
      .catch((error) => {
        console.error("Error fetching login users for assessments:", error);
      });
  }, []);

  useEffect(() => {
    fetchUserDetails();
  }, [fetchUserDetails]);

  useEffect(() => {
    if (user?.role === "CARAA" || user?.role === "CARAU" || user?.role === "CARA") {
      axios.get(`${API_URL}api/announcements/unread/`, { withCredentials: true })
        .then(res => {
          if (res.data.status === 200) {
            setUnreadAnnouncementsCount(res.data.unread_count || 0);
          }
        })
        .catch(err => console.error("Error fetching unread announcements", err));
    }
  }, [user]);

  useEffect(() => {
    const handleProfileUpdate = () => {
      fetchUserDetails();
    };

    window.addEventListener("user-profile-updated", handleProfileUpdate);return () => {
      window.removeEventListener("user-profile-updated", handleProfileUpdate);
    };
  }, [fetchUserDetails]);
  const path = window.location.pathname;
  const showDropdown = path.includes("assessment_dashboard");
  const { caraUser, tprmUser, caraAdmin, tprmUseruser } = useAuth();
  const roleName = localStorage.getItem("role");
  console.log("caraUser tprm name =>", tprmUser?.user_type);

  let role_name;

  // Check role_name first for more specific roles
  if ((user?.role_name || "").toLowerCase().trim() === "internal auditor") {
    role_name = t('role.internalAuditor', { ns: 'header', defaultValue: 'Internal Auditor' });
  } else if ((user?.role_name || "").toLowerCase().trim() === "external auditor") {
    role_name = t('role.externalAuditor', { ns: 'header', defaultValue: 'External Auditor' });
  } else if (user?.user_type === "2" || user?.user_type === 2) {
    role_name = t('role.manager', { ns: 'header', defaultValue: 'Manager' });
  } else if (user?.user_type === "17" || user?.user_type === 17) {
    role_name = t('role.projectHead', { ns: 'header', defaultValue: 'Project Head' });
  } else if (user?.user_type === "16" || user?.user_type === 16) {
    role_name = t('role.auditor', { ns: 'header', defaultValue: 'Auditor' });
  } else if (user?.user_type === "18" || user?.user_type === 18) {
    role_name = t('role.caraOfficer', { ns: 'header', defaultValue: 'CARA Officer' });
  } else if (user?.user_type === "1" || user?.user_type === 1) {
    role_name = t('role.caraAdmin', { ns: 'header', defaultValue: 'CARA Admin' });
  } else if (user?.role === "VRM") {
    role_name = t('role.vrmUser', { ns: 'header', defaultValue: 'VRM User' });
  } else if (user?.user_type === "19" || tprmUseruser?.user_type === 19 || roleName === "TPRM Admin" ){
    role_name = t('role.tprmUser', { ns: 'header', defaultValue: 'TPRM User' });
  } else if (tprmUser?.user_type === "14" || tprmUser?.user_type === 14 ) {
    role_name = t('role.tprmAdmin', { ns: 'header', defaultValue: 'TPRM Admin' });

  } else if (caraUser?.user_type === 1) {
    role_name = t('role.caraAdmin', { ns: 'header', defaultValue: 'CARA Admin' });
  }

  let login_user;
  if (user) {
    login_user = `${user.first_name} ${user.last_name}`;
  }
  else if (tprmUser?.user_type === "14") {
    login_user = `${tprmUser.first_name} ${tprmUser.last_name}`;
  }
  else if (tprmUseruser?.user_type === "19") {
    login_user = `${tprmUseruser.first_name} ${tprmUseruser.last_name}`;
  }

  const preventDefault = (e) => {
    e.preventDefault();
  };

  let daysRemaining = null;
  let showExpiryWarning = false;
  if (user && user.end_date && user.role === 'CARAA') {
    const end = new Date(user.end_date);
    const today = new Date();
    end.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);
    const diffTime = end - today;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    
    if (diffDays <= 15) {
      daysRemaining = diffDays;
      showExpiryWarning = true;
    }
  }

  return (
    <div>
      {/* Navbar */}
      <nav className="main-header navbar navbar-expand navbar-white navbar-light fixed-top">
        {/* Left navbar links */}
        <ul className="navbar-nav">
          <li className="nav-item ml-2">
            <a 
              className="nav-link" 
              data-widget="pushmenu" 
              href="#" 
              role="button"
              onClick={(e) => {
                e.preventDefault();
                const body = document.body;
                if (window.innerWidth >= 992) {
                  body.classList.toggle('sidebar-collapse');
                } else {
                  if (body.classList.contains('sidebar-open')) {
                    body.classList.remove('sidebar-open');
                    body.classList.add('sidebar-collapse');
                  } else {
                    body.classList.add('sidebar-open');
                    body.classList.remove('sidebar-collapse');
                  }
                }
              }}
            >
              <i className="fas fa-bars" />
            </a>
          </li>
          <Breadcrumbs />
          {/* Dropdown: Only show if route is /assessment_dashboard */}
          {showDropdown && (
            <li className="nav-item ml-3 mt-1">
              <select
                className="form-select"
                value={selectedDropdown}
                onChange={(e) => {
                  const value = e.target.value;
                  setSelectedDropdown(value);
                  const params = new URLSearchParams(location.search);
                  params.set("framework", value);
                  navigate({
                    pathname: location.pathname,
                    search: params.toString(),
                  }, { replace: true });
                }}
                style={{ width: "200px", height: "30px", fontSize: "14px" }}>
                {[
                  { label: t('option.nistCsf20', { ns: 'header', defaultValue: 'NIST-CSF 2.0' }), value: "NIST-CSF 2.0", key: "NIST CSF 2.0 Assessment" },
                  { label: t('option.nistCsf11', { ns: 'header', defaultValue: 'NIST-CSF 1.1' }), value: "NIST-CSF 1.1", key: "NIST CSF 1.0 Assessment" },
                  { label: t('option.nistRansomware', { ns: 'header', defaultValue: 'NIST Ransomware' }), value: "NIST Ransomware", key: "NIST Ransomware Assessment" },
                  { label: t('option.nistAiRmf', { ns: 'header', defaultValue: 'NIST AI RMF' }), value: "NIST AI RMF", key: "NIST AI RMF Assessment" },
                  { label: t('option.iso270012022', { ns: 'header', defaultValue: 'ISO 27001:2022' }), value: "ISO 27001:2022", key: "ISO 27001 Assessment" },
                  { label: t('option.cisV81', { ns: 'header', defaultValue: 'CIS V8.1' }), value: "CIS V8.1", key: "CIS V8.1 Assessment" },
                  { label: t('option.rbiCsfFramework', { ns: 'header', defaultValue: 'RBI CSF Framework' }), value: "RBI CSF Framework", key: "RBI CSF Assessment" },
                ].map((item) => (
                  allowedAssessments.includes(item.key) && (
                    <option key={item.value} value={item.value}>{item.label}</option>
                  )
                ))}
              </select>
            </li>
          )}
        </ul>
        {/* Right navbar links */}
          <ul className="navbar-nav ml-auto">
            <li class="nav-item ">
              <Link class="nav-link d-flex align-items-center" to="/announcement" id="announcementsDropdown" role="button" onClick={() => setUnreadAnnouncementsCount(0)}>
                <img src="../img/announcement-icon.svg" style={{ height: 20, width: 20, marginRight: 8 }} className="icon-style" />
                <span>{t('nav.announcements', { ns: 'header', defaultValue: 'Announcements' })}</span>
                {unreadAnnouncementsCount > 0 && (
                  <span className="badge rounded-pill bg-danger ms-2" style={{ fontSize: '0.65rem', marginLeft: '6px' }}>
                    {unreadAnnouncementsCount}
                  </span>
                )}
              </Link>
            </li>
          
          {showExpiryWarning && (
            <li className="nav-item dropdown d-flex align-items-center me-2 mt-1">
              <a className="nav-link position-relative" href="#" id="expiryDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                <i className="fas fa-bell" style={{ fontSize: "1.3rem", color: "#253b7e" }}></i>
                <span className="position-absolute badge rounded-pill bg-danger" style={{ fontSize: "0.6rem", top: '2px', right: '0px', padding: '0.25em 0.45em' }}>
                  1
                </span>
              </a>
              <ul className="dropdown-menu dropdown-menu-end p-3 shadow border-0" aria-labelledby="expiryDropdown" style={{ width: '320px', right: 0, left: 'auto' }}>
                <li>
                  <h6 className="dropdown-header text-danger fw-bold px-0 text-wrap">
                    <i className="fas fa-exclamation-triangle me-2"></i> License Expiring Soon
                  </h6>
                </li>
                <li><hr className="dropdown-divider" /></li>
                <li>
                  <p className="mb-0 text-wrap text-muted" style={{ fontSize: '0.9rem', whiteSpace: 'normal' }}>
                    Your CARA Admin license will expire in <strong className="text-dark">{daysRemaining >= 0 ? daysRemaining : 0} day{daysRemaining !== 1 ? 's' : ''}</strong>. 
                    Please contact support or renew your subscription to avoid interruption.
                  </p>
                </li>
              </ul>
            </li>
          )}
          <li className="nav-item"> <span className="nav-link d-flex align-items-center"><strong> | </strong></span></li>
          <li className="nav-item">
            <Link to="/email_support" className="nav-link d-flex align-items-center">
              <img src="../img/envelope-icon.svg" style={{ height: 20, width: 20, marginRight: 8 }} className="icon-style" />
              <span>{t('nav.emailSupport', { ns: 'header', defaultValue: 'Email Support' })}</span>
            </Link>
          </li>
          <li className="nav-item"> <span className="nav-link d-flex align-items-center"><strong> | </strong></span></li>
          {/* <!-- User Dropdown --> */}
          <li className="nav-item dropdown d-flex align-items-center">
            {/* Profile Link */}
            <Link
              className="nav-link d-flex align-items-center"
              to="/profile"
              style={{ textDecoration: "none" }}
            >
              {user?.file ? (
                <img
                  src={user.file}
                  className="user-avatar me-2"
                  alt="User"
                />
              ) : (
                <i className="bi bi-person-circle me-2" style={{ fontSize: "2.5rem", color: "#6c757d" }}></i>
              )}

              <div className="d-flex flex-column mr-2 mb-1 mt-2">
                <span className="fw-bold text-dark" style={{ fontSize: "16px", fontFamily: "'Open Sans', Arial, Helvetica, sans-serif", lineHeight: "1.2" }}>
                  {login_user}
                </span>
                <span className="text-muted" style={{ fontSize: "11.9px", fontFamily: "'Open Sans', Arial, Helvetica, sans-serif", lineHeight: "1.2" }}>
                  {role_name}
                </span>
              </div>
            </Link>

            {/* Dropdown Toggle Icon */}
            {/* <a
              className="nav-link dropdown-toggle"
              href="#"
              role="button"
              id="userDropdown"
              data-bs-toggle="dropdown"
              aria-expanded="false"
              onClick={preventDefault}
            ></a> */}

            {/* Dropdown Menu */}
            <ul className="dropdown-menu" aria-labelledby="userDropdown">
              <li>
                <a className="dropdown-item" href="/tprm_login">
                  <i className="fas fa-sign-in-alt me-2"></i> {t('nav.tprmLogin', { ns: 'header', defaultValue: 'TPRM Login' })}
                </a>
              </li>
              <li><hr className="dropdown-divider" /></li>
              <li>
                <a className="dropdown-item" href="/vrm_login">
                  <i className="fas fa-sign-in-alt me-2"></i> {t('nav.vrmLogin', { ns: 'header', defaultValue: 'VRM Login' })}
                </a>
              </li>
              <li><hr className="dropdown-divider" /></li>
              <li>
                <a className="dropdown-item" href="/audit_login">
                  <i className="fas fa-sign-in-alt me-2"></i> {t('nav.auditLogin', { ns: 'header', defaultValue: 'Audit Login' })}
                </a>
              </li>
              <li><hr className="dropdown-divider" /></li>
              <li>
                <a className="dropdown-item" href="/cara_login">
                  <i className="fas fa-sign-in-alt me-2"></i> {t('nav.caraLogin', { ns: 'header', defaultValue: 'CARA Login' })}
                </a>
              </li>
            </ul>
          </li>

        </ul>
      </nav>
      {/* {showDropdown && (
        <AssessmentsDashboard selectedDropdown={selectedDropdown} />
      )} */}
    </div>

  );
}

export default Header;